import HttpRequest from '@/config/axios.config'

export type ProductSearchParams = {
  search?: string
  filter?: string
  page_number: number
  page_size?: number
  sort?: string
}

export type ProductFilterPayload = {
  search?: string | null
  number?: string | string[] | null
  name?: string | string[] | null
  suppliers?: string | string[] | null
  [key: string]: any
}

export type ProductPropertyValuePayload = {
  field: string
  name: string
  value: string | number | Record<string, unknown>[]
  data_type: string
  description?: {
    name: string
    field: string
    value?: string
  }
  required: boolean
  display_order: number
}

export type ProductSource = 'manual' | ''

export type CreateProductPayload = Partial<{
  picture: string | null
  number: string
  name: string
  supplier: string | null
}> & {
  status: 'active'
  source: ProductSource
  property_values: ProductPropertyValuePayload[]
}

export type UpdateProductPayload = Partial<
  Omit<CreateProductPayload, 'property_values' | 'source'>
> & {
  property_values?: ProductPropertyValuePayload[]
}

export async function getProductRef(
  params: ProductSearchParams,
  filterPayload: ProductFilterPayload = {}
) {
  return await HttpRequest.post('/products/search-advance', filterPayload, {
    params: {
      page_number: params.page_number,
      page_size: params.page_size,
      ...(params.sort && { sort: params.sort }),
    },
  })
}

export async function getProductSettingRef() {
  return await HttpRequest.get('/company-settings', {
    params: { name: 'product' },
  })
}

export async function getProductSupplierRef(companyId?: string) {
  return await HttpRequest.get('/suppliers', {
    params: {
      status: 'active',
      all: true,
      type: 'supplier',
      ...(companyId && { company_id: companyId }),
    },
  })
}

export async function getProductFactoryRef(
  companyId?: string,
  supplierId?: string
) {
  return await HttpRequest.get('/suppliers', {
    params: {
      status: 'active',
      all: true,
      type: 'factory',
      ...(companyId && { company_id: companyId }),
      ...(supplierId && { parent: supplierId }),
    },
  })
}

export async function createProducRef(payload: CreateProductPayload) {
  return await HttpRequest.post('/products', payload)
}

export async function getProductDetailRef(productId: string) {
  return await HttpRequest.get(`/products/${productId}`)
}

export async function updateProductRef(
  productId: string,
  payload: UpdateProductPayload
) {
  return await HttpRequest.put(`/products/${productId}`, payload)
}

export async function deleteProductRef(productId: string) {
  return await HttpRequest.delete(`/products/${productId}`)
}

export async function getProductCategoryFilterRef() {
  return await HttpRequest.get('/products/advance_filter_custom_column', {
    params: {
      all: true,
      field: 'category',
    },
  })
}
export async function getProductFieldPermissionRef() {
  return await HttpRequest.get(`/permissions/field-permissions/products`)
}
